interface DeletedRecordsPermissions {
  canDeleteJob?: boolean;
  canDeleteOrder?: boolean;
  canDeleteProject?: boolean;
  canDeleteTicket?: boolean;
}

export function canViewAnyDeletedRecords({
  canDeleteJob,
  canDeleteOrder,
  canDeleteProject,
  canDeleteTicket,
}: DeletedRecordsPermissions) {
  return Boolean(canDeleteProject || canDeleteOrder || canDeleteJob || canDeleteTicket);
}
